import React from "react";
import { Navbar, Dropdown } from "react-bootstrap";
import { BsListNested } from "react-icons/bs";
import { CiBellOn } from "react-icons/ci";
import { IoLogOutOutline } from "react-icons/io5";
import { PiUserCircle } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../store/slices/auth";

export default function HeaderNav({ mobileMenuclick }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await dispatch(logout()).unwrap()
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const styleIcons = {

    width: "43px",
    height: "43px",
    borderRadius: "14px",
    border: "1px solid rgba(132, 81, 255, 0.25)",
    background: "rgba(132, 81, 255, 0.12)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#8451ff",
    boxShadow:
      "0 8px 24px rgba(132, 81, 255, 0.18), inset 0 1px 0 rgba(255,255,255,0.35)",
    transition: "all 0.3s ease",
    cursor: "pointer",

  }

  return (
    <Navbar bg="white" className="top-header shadow-sm px-4">
      <div className="header-inner d-flex align-items-center w-100">
        <button className="hamburger-btn" onClick={mobileMenuclick}>
          <BsListNested />
        </button>
        <div className="welcome-text ms-3">
          <span>WELCOME!</span>
        </div>
        <div className="header-actions d-flex align-items-center ms-auto">

          <button
            className="icon-btn notification-btn"
            style={styleIcons}
          >
            <CiBellOn style={{ fontSize: "24px" }} />
            <span
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                width: "9px",
                height: "9px",
                borderRadius: "50%",
                background: "#ff4d6d",
                border: "2px solid #fff",
                boxShadow: "0 0 10px rgba(255,77,109,.6)",
              }}
            />
          </button>

          <Dropdown align="end">
            <Dropdown.Toggle
              as="div"
              className="icon-btn dropdown-toggle-custom"
              style={styleIcons}
            >
              <PiUserCircle style={{ fontSize: "22px" }} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => navigate("/teacher/teacherprofile")}>Profile</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item className="text-danger" onClick={handleLogout}>
                <IoLogOutOutline style={{ marginRight: "6px" }} />
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </Navbar>
  );
}
